module.exports = __webpack_public_path__ + "static/media/tips-on.3d45f185.svg";